import React from "react";

/** @jsx jsx */
import { jsx, css, keyframes } from '@emotion/react';
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GameClient } from "../gameClient";
import { Colors } from "../palettes/colorPalette";
import { backgroundTextureMarket } from "../uiConstants";

const offerTab = css`
    background: url(${backgroundTextureMarket});
	background-color: ${Colors.UIMarketBackground};
	padding: .5vh 3vw;
	width: fit-content;
	border-bottom-left-radius: .5vw;
	border-bottom-right-radius: .5vw;
    margin: 0 auto;
    font-size: 2vh;
`;

const offerStyleHide = css`
	display: none;
`;

const keys = keyframes`
	0% {
		background: ${Colors.UIBackground};
	}
	50% {
		background: ${Colors.UITimer};
	}
	100% {
		background: ${Colors.UIBackground};
	}
`;

const bounce = css`
	animation: ${keys} 0.5s infinite alternate ease-in-out;
`;

declare var gameClient: GameClient;

interface CapacityPanelProps {
    hide: boolean;
    capacity: number;
    numCells: number;
    sendInfo: (info: string) => void;
    flashWarning: boolean;
}

export const CapacityPanel: React.FC<CapacityPanelProps> = (props) => {
    const hover = () => {
        props.sendInfo('How many cells you have. Increase your level to increase your capacity!');
    };
    return (
        <div css={css`
            ${offerTab}
            ${props.hide && offerStyleHide}
            animation: ${props.flashWarning ? css`${keys} 1s infinite` : ''} 
        `} onMouseEnter={hover}>
            <FontAwesomeIcon icon={faUsers} />
            <span css={css`margin-left: 1vh`}>{`${props.numCells}/${props.capacity}`}</span>
        </div>
    );
};